/**
 * withFavourites
 * HOC for wrapping the provided component with FavouritesProvider
 */

import React from 'react'

import FavouritesProvider from './favourites-provider'

export default function withFavourites (WrappedComponent) {
  return function FavouritesProviderHOC(props) {
    return (
      <FavouritesProvider>
        <WrappedComponent {...props} />
      </FavouritesProvider>
    )
  }
}
